<template>

    <div class="panel" :class="{ loading: loading }">
        <div v-if="$slots['header']" class="panel-header">
            <slot name="header"></slot>
        </div>
        <div v-else-if="$slots['title']" class="panel-header">
            <span class="panel-title">
                <slot name="title"></slot>
            </span>
        </div>
        <div v-if="loading" class="panel-body">
            <v-loader />
        </div>
        <div v-else class="panel-body">
            <slot name="body"></slot>
        </div>
        <div v-if="$slots['footer']" class="panel-footer">
            <slot name="footer"></slot>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .panel {

        background: white;
        border: 1px solid $color-rule;
        border-radius: 5px;
        margin: 0 auto;

        &.loading .panel-body {
            align-items: center;
            display: flex;
            justify-content: center;
        }

        .panel-header {
            border-bottom: 1px solid $color-rule-light;
            padding: 20px;
            text-align: left;
            .panel-title {
                @include font-semibold(18px);
            }
        }

        .panel-body {
            padding: 30px;
            p {
                @include font-medium(14px);
                line-height: 1.6em;
                margin: 0 0 10px 0;
                text-align: center;
                &.small {
                    font-size: 13px;
                }
            }
            *:last-child {
                margin-bottom: 0;
            }
        }

        .panel-footer {
            border-top: 1px solid $color-rule;
            display: flex;
            justify-content: space-between;
            padding: 30px;
            text-align: center;
        }

    }

</style>

<script>

export default {

    props: {
        loading: {
            type: Boolean,
            required: false,
        },
    },

}

</script>